import React, { useEffect, useMemo, useState } from 'react';
import './TripGuarantee.css';

function formatTextForOrg(text: string, org: string) {
  text = text.replace('${ORG}', org);
  if (org === 'GI') {
    text = text.replace(/Ride Guarantee/g, 'Ride Assured');
  }
  return text;
}

function Table({
  data
}: {
  data: Array<{ description: string; refund: string; amountReceived: string }>;
}) {
  const [org, setOrg] = useState('MMT');

  useEffect(() => {
    if (global.window) {
      const searchParams = new URLSearchParams(window.location.search);
      const ORG = searchParams.get('org')?.includes('gi') ? 'GI' : 'MMT';
      setOrg(ORG);
    }
  }, []);

  return (
    <div className="tableContainer">
      {data.map((item, index) => {
        const colClassName =
          index === 0 ? 'font12 latoBold greyishTxt' : 'font12 latoRegular';

        return (
          <div className={`row ${index === 0 ? 'head' : ''}`}>
            <div className={`col lineHeight14 ${colClassName}`}>
              {formatTextForOrg(item.description, org)}
            </div>
            <div
              className={`col lineHeight14 ${colClassName} ${
                index > 0 ? 'latoBold' : ''
              }`}
            >
              {formatTextForOrg(item.refund, org)}
            </div>
            <div
              className={`col lineHeight14 ${colClassName} ${
                index > 0 ? 'latoBold greenText' : ''
              }`}
            >
              {formatTextForOrg(item.amountReceived, org)}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export const TripGuarantee = ({ data }) => {
  const { tripGuarantee } = data;

  const [org, setOrg] = useState('MMT');

  useEffect(() => {
    if (global.window) {
      const searchParams = new URLSearchParams(window.location.search);
      const ORG = searchParams.get('org')?.includes('gi') ? 'GI' : 'MMT';
      setOrg(ORG);
    }
  }, []);

  return (
    <div className="page">
      <div className="banner">
        <img
          alt="trip guarantee"
          src={tripGuarantee.banner.icon}
          width={40}
          height={40}
        />
        <div>
          <div className="font16 latoBlack appendBottom3">
            {formatTextForOrg(tripGuarantee.banner.title, org)}
          </div>
          <div className="font14 latoRegular">
            {formatTextForOrg(tripGuarantee.banner.description, org)}
          </div>
        </div>
      </div>

      <div className="coveredCaseContainer">
        <div className="font16 latoBold">
          {formatTextForOrg(tripGuarantee.coveredCases.title, org)}
        </div>

        {tripGuarantee.coveredCases.cases.map(caseItem => (
          <>
            <div className="coveredCase">
              <img
                src={caseItem.icon}
                alt={caseItem.title}
                width={24}
                height={24}
              />
              <span className="latoBold font14">
                {formatTextForOrg(caseItem.title, org)}
              </span>
            </div>
            <Table data={caseItem.data}></Table>
          </>
        ))}

        <div className="font12 latoRegular appendTop15">
          {tripGuarantee.coveredCases.footerText}
        </div>
      </div>

      <div className="claimProcessContainer">
        <div className="font16 latoBold">
          {tripGuarantee.claimProcess.title}
        </div>
        <div className="divider"></div>
        <div>
          <div className="latoBlack font16 appendBottom15 darkGreyText">
            {tripGuarantee.claimProcess.cabNoShow.title}
          </div>
          <div
            className="font14 latoRegular darkGreyText lineHeight16"
            dangerouslySetInnerHTML={{
              __html: tripGuarantee.claimProcess.cabNoShow.description
            }}
          ></div>
        </div>
        <div className="divider"></div>
        <div>
          <div className="latoBlack font16 appendBottom15 darkGreyText">
            {formatTextForOrg(
              tripGuarantee.claimProcess.missedFlight.title,
              org
            )}
          </div>
          <div
            className="font14 latoRegular darkGreyText lineHeight16"
            dangerouslySetInnerHTML={{
              __html: tripGuarantee.claimProcess.missedFlight.description
            }}
          ></div>
          <div className="requiredDocumentsContainer">
            <div className="latoBlack font16 appendBottom15">
              {formatTextForOrg(
                tripGuarantee.claimProcess.missedFlight.requiredDocuments.title,
                org
              )}
            </div>
            <div className="latoRegular font12 darkGreyText appendBottom15">
              {formatTextForOrg(
                tripGuarantee.claimProcess.missedFlight.requiredDocuments
                  .description,
                org
              )}
            </div>
            {tripGuarantee.claimProcess.missedFlight.requiredDocuments.documents.map(
              doc => {
                return (
                  <div className="appendBottom15 makeFlex">
                    <img
                      src="https://go-assets.ibcdn.com/u/MMT/images/1724147195944-tick.webp"
                      alt="tick"
                      width={16}
                      height={16}
                      className="appendRight8"
                    />
                    <div>
                      <div className="font14 latoBold appendBottom3">
                        {formatTextForOrg(doc.title, org)}
                      </div>
                      <div className="font14 latoRegular darkGreyText">
                        {formatTextForOrg(doc.description, org)}
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>

          <div className="appendTop15">
            <div className="font14 latoBold appendBottom15">
              {formatTextForOrg(
                tripGuarantee.claimProcess.missedFlight.stepsToClaim.title,
                org
              )}
            </div>
            {tripGuarantee.claimProcess.missedFlight.stepsToClaim.steps.map(
              (step, index, arr) => {
                return (
                  <div className="makeFlex">
                    <img
                      className="appendRight8 zIndex10"
                      src="https://go-assets.ibcdn.com/u/MMT/images/1724147687252-purple_check_circle.webp"
                      alt="step"
                      width={16}
                      height={16}
                    />

                    <div
                      className={`flexOne font14 latoRegular darkGreyText lineHeight18 paddingB16 ${
                        index < arr.length - 1 ? 'pipe' : ''
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: formatTextForOrg(step, org)
                      }}
                    ></div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
      <div className="faqContainer">
        <div className="latoBlack font16 appendBottom15">
          {formatTextForOrg(tripGuarantee.faqs.title, org)}
        </div>
        {tripGuarantee.faqs.faqs.map(faq => {
          return (
            <div className="appendBottom25">
              <div className="font16 latoBold lineHeight18 darkGreyText">
                {formatTextForOrg(faq.title, org)}
              </div>
              <div
                className="font14 latoRegular lineHeight18 appendTop8 darkGreyText"
                dangerouslySetInnerHTML={{
                  __html: formatTextForOrg(faq.description, org)
                }}
              ></div>
            </div>
          );
        })}
      </div>
      <div className="footerCtaContainer">
        <a href={tripGuarantee.footerLink} className="font14 latoBold">
          {formatTextForOrg(tripGuarantee.footerCta, org)} →
        </a>
      </div>
    </div>
  );
};

TripGuarantee.fetchData = async () => {
  const cacheKey = 'HTML_STATIC_DOC_RIDE-GUARANTEE.HTML';

  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    templateData: {
      templateName: 'DOC_TRIP_GUARANTEE_TERMS',
      metaTitle: 'Cabs Ride Guarantee Terms and Conditions',
      metaDescription: '',
      metaKeywords: '',
      analytics: ``,
      h1Title: 'Ride Guarantee',
      extraInfo: '',
      breadcrumb: [],
      externalJs: '',
      descriptionInHtml: ``
    },
    tripGuarantee: {
      banner: {
        icon:
          'https://go-assets.ibcdn.com/u/MMT/images/1723438360650-trip-safety.webp',
        title: 'Ride Guarantee',
        description: 'Ensuring you reach airport on-time!'
      },
      coveredCases: {
        title: 'Covered cases',
        footerText: '*Full refund on the amount paid',
        cases: [
          {
            icon:
              'https://go-assets.ibcdn.com/u/MMT/images/1723438753722-location-unavailable.webp',
            title: 'Cab Did Not Arrive',
            data: [
              {
                description: '',
                refund: 'Refund',
                amountReceived: 'You get'
              },
              {
                description: 'If cab doesn’t come',
                refund: 'Full refund + ₹300 voucher',
                amountReceived: 'Amount paid + ₹300 *'
              }
            ]
          },
          {
            icon:
              'https://go-assets.ibcdn.com/u/MMT/images/1723438803865-missed-flight.webp',
            title: 'Missed Flight',
            data: [
              {
                description: '',
                refund: 'Refund',
                amountReceived: 'You get'
              },
              {
                description: 'Missed flight due to cab delay',
                refund: 'Flight price upto ₹5,000',
                amountReceived: 'Upto ₹5,000'
              },
              {
                description: 'Missed flight because cab did not arrive',
                refund: 'Full Refund + ₹300 voucher + Flight Price upto ₹5,000',
                amountReceived: 'Upto Amount paid + ₹300 + ₹5,000'
              }
            ]
          }
        ]
      },
      claimProcess: {
        title: 'How to claim refund?',
        cabNoShow: {
          title: 'In case your cab did not arrive',
          description:
            'Sit back & relax!<br /> We will initiate the refund from our side.<br/> <br/>If the refund is not initiated within 2 hours, you can reach out to our Customer Support at <strong><a href="tel:01244628747">01244628747</a></strong>'
        },
        missedFlight: {
          title: 'In case you missed your flight',
          description:
            '<div style="display:flex; align-items:center;"><span style="flex: 1; margin-right:8px;">You can start your claim with our insurance partner <strong>Acko</strong></span> <img style="margin-left:auto;" width="34" src="https://go-assets.ibcdn.com/u/MMT/images/1739337937293-acko_logo.webp" alt="acko" /></div>',
          requiredDocuments: {
            title: 'Required Documents to raise the claim',
            description:
              'Collect these documents before beginning the process on Acko App for smoother processing',
            documents: [
              {
                title: 'No Show Travel Certificate',
                description:
                  'A certificate from the airline confirming you missed your flight.'
              },
              {
                title: 'Flight Ticket',
                description:
                  'Your original flight ticket showing the scheduled departure time and payment details.'
              }
            ]
          },
          stepsToClaim: {
            title: 'Steps to Claim refund on Acko App',
            steps: [
              'Log in to the Acko app with the mobile number added in Traveller Details while booking the cab. You can find this number in the Traveller Details section on My Trips.<br/><a class="font12 latoBold makeFlex hrtlCenter appendTop3" href="https://www.acko.com/"><img style="margin-right:4px;" src="https://go-assets.ibcdn.com/u/MMT/images/1724150114286-link.webp" width="13"/>Acko Website</a>',
              'Click on the <strong>Policies</strong> tab. The associated insurance will be available here.',
              'Select <strong>${ORG} Trips</strong> policy.',
              'Click on <strong>Claim</strong> and select <strong>Issues relating to the trip</strong> option.',
              'Enter your <strong>Gender, City, and Date of Birth.</strong>',
              'Share the reason for missing the flight under the <strong>How did the incident happen</strong> section. Include the flight departure date, time, flight number, airport code, flight PNR, and ticket price.',
              'Upload the <strong>No Show Travel Certificate</strong> and the <strong>Flight Ticket</strong>.',
              'Enter the bank account details where you want to receive the claim reimbursement.',
              'Verify details & submit.',
              'Your claim will be processed within 2 hours, provided the information is validated by Acko.'
            ]
          }
        }
      },
      faqs: {
        title: 'FAQs',
        faqs: [
          {
            title: 'How long will it take to get my refund?',
            description:
              "If the cab doesn't arrive, we’ll initiate your refund 30 minutes after the scheduled pickup time. <br /> For missed flight, please raise a claim on the Acko app. Once your claim is successfully validated, the refund will be processed within 2 hours."
          },
          {
            title: 'Where will the refund be transferred?',
            description:
              "If the cab doesn't arrive, the refund will be credited to your original payment method, and voucher details will be available in My Trips.<br /> For missed flight, the reimbursement will be transferred to the bank account provided when submitting your claim on the Acko app."
          },
          {
            title: 'Is there a time limit to raise a claim?',
            description:
              'For cab no-show, contact Customer Support at <strong><a href="tel:01244628747">01244628747</a></strong> within 24 hours of your scheduled pickup time if you haven’t received your refund or voucher.<br /> For missed flight, you can raise a claim on the Acko app within 7 days of the flight’s departure.'
          },
          {
            title: 'What happens if I cancel my cab booking?',
            description:
              'The Ride Guarantee program fee is non-refundable. Any amount paid for the program will be deducted from your refund.<br /> If you wish to cancel because your cab is delayed by more than 15 minutes after the scheduled pickup time, please contact Customer Support at <strong><a href="tel:01244628747">01244628747</a></strong>. In this case, you’ll receive a refund for the cab booking and an additional Rs 300 voucher.'
          },
          {
            title: 'What happens if I modify my cab booking?',
            description:
              'The Ride Guarantee program will not apply to the new booking if you modify your existing booking.'
          },
          {
            title: 'What is the validity of the Rs 300 voucher?',
            description:
              'The voucher is valid for 60 days from the date of issue and can be used once on any future cab booking on the ${ORG} platform. It will only apply to bookings made through the same account as the original booking.'
          },
          {
            title:
              'Will I be eligible for a missed flight refund if the traveler’s name on the cab booking is different from the flight booking?',
            description:
              'No, only the traveler whose name is on the cab booking is eligible for the missed flight refund. Therefore, the traveler’s name must match on both the cab and flight bookings.'
          }
        ]
      },
      footerCta: 'Read Detailed Terms & Conditions',
      footerLink:
        'https://tripmoneycmshtmlak.mmtcdn.com/undefined/202407_01_Tn_C_MMT_Airport_Cab_V1_45f1e8d277.pdf'
    }
  };
};

export default TripGuarantee;
